'use client';

import dynamic from 'next/dynamic';
import type { MonochromeMapMarker, CoverageCountry, MapRoute } from './MonochromeMap';

const MonochromeMap = dynamic(
  () => import('./MonochromeMap').then((mod) => mod.MonochromeMap),
  {
    ssr: false,
    loading: () => (
      <div className="w-full h-full flex items-center justify-center bg-blue-50 rounded-lg">
        <div className="text-gray-400 text-sm">Loading map...</div>
      </div>
    ),
  }
);

interface MonochromeMapWrapperProps {
  markers?: MonochromeMapMarker[];
  coverageCountries?: CoverageCountry[];
  routes?: MapRoute[];
  center?: [number, number];
  zoom?: number;
  className?: string;
  height?: number | string;
}

export function MonochromeMapWrapper(props: MonochromeMapWrapperProps) {
  return <MonochromeMap {...props} />;
}
